import { UI_LANGS } from "./url-i18n.js";

/** The EDU demo and both portals have their own page in every interface language. */
export const EDU_PAGE_LANGS = Object.freeze([...UI_LANGS]);

const SEGMENTS = Object.freeze({ demo: "edu-demo", eduPortal: "edu-portal", portal: "portal" });
export const EDU_PAGES = Object.freeze(Object.keys(SEGMENTS));

export function eduPageLang(uiLang) {
  const code = String(uiLang || "").trim().toLowerCase();
  return EDU_PAGE_LANGS.includes(code) ? code : "en";
}

export function getEduPagePath(page, uiLang, suffix = "") {
  const lang = eduPageLang(uiLang);
  return `${lang === "de" ? "" : `/${lang}`}/${SEGMENTS[page] || SEGMENTS.demo}${String(suffix || "")}`;
}

export function eduPathsByUiLang(page) {
  return Object.fromEntries(UI_LANGS.map((code) => [code, getEduPagePath(page, code)]));
}

export function getEduDemoPath(uiLang, suffix = "") {
  return getEduPagePath("demo", uiLang, suffix);
}

export function getEduPortalPath(uiLang, suffix = "") {
  return getEduPagePath("eduPortal", uiLang, suffix);
}

export function getLearnerPortalPath(uiLang, suffix = "") {
  return getEduPagePath("portal", uiLang, suffix);
}

export function allEduPagePaths() {
  return EDU_PAGES.flatMap((page) => EDU_PAGE_LANGS.map((lang) => getEduPagePath(page, lang)));
}
